/**
 * Guided first-sale onboarding API.
 */

import {
  OrganizationOnboardingResponse,
  OrganizationOnboardingUpdate,
} from '../models/organization';
import { authenticatedHttpClient } from './httpClient';

export async function fetchOrganizationOnboarding(
  organizationId: string
): Promise<OrganizationOnboardingResponse> {
  return authenticatedHttpClient.get<OrganizationOnboardingResponse>(
    `/organizations/${organizationId}/onboarding`
  );
}

export async function patchOrganizationOnboarding(
  organizationId: string,
  update: OrganizationOnboardingUpdate
): Promise<OrganizationOnboardingResponse> {
  return authenticatedHttpClient.patch<OrganizationOnboardingResponse>(
    `/organizations/${organizationId}/onboarding`,
    update
  );
}

export async function restartOrganizationOnboarding(
  organizationId: string
): Promise<OrganizationOnboardingResponse> {
  return authenticatedHttpClient.post<OrganizationOnboardingResponse>(
    `/organizations/${organizationId}/onboarding/restart`
  );
}
